import { useState } from 'react';
import FadeIn from '../components/FadeIn';
import { SERVICES, WA_URL, WA_NUMBER } from '../data/constants';

const INITIAL_FORM = { nombre: '', empresa: '', telefono: '', email: '', servicio: '', mensaje: '' };

const CONTACT_INFO = [
  { icon: '📞', label: 'Celular',             content: <a href="tel:+573128348779">312 834 87 79</a> },
  { icon: '✉️', label: 'Correo electrónico', content: <a href="mailto:mantenimiento@myrg.com.co">mantenimiento@myrg.com.co</a> },
  { icon: '📍', label: 'Dirección',           content: <span>Cra 70 # 105 D - 29, Medellín</span> },
  { icon: '🏢', label: 'NIT',                 content: <span>901.248.424-3</span> },
  { icon: '🕐', label: 'Horario',             content: <span>Lun–Vie 7am–6pm · Emergencias 24/7</span> },
];

export default function Contacto() {
  const [form, setForm] = useState(INITIAL_FORM);
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // TODO: descomentar cuando el webhook de n8n esté listo
    // await fetch('https://TU_N8N/webhook/mrg-contacto', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify(form),
    // });
    setSent(true);
  };

  return (
    <section className="sec sec-warm" style={{ paddingTop: 108 }}>
      <FadeIn>
        <div className="sec-tag">Estamos para ayudarte</div>
        <h2 className="sec-title">Contáctanos</h2>
        <p className="sec-sub">
          Cuéntanos sobre tu estación y el servicio que necesitas. Te respondemos rápido.
        </p>
      </FadeIn>

      <div className="ct-grid">
        {/* Información de contacto */}
        <FadeIn delay={70}>
          <div>
            <h3 style={{ fontSize: 11, fontWeight: 700, color: '#1C2B3A', marginBottom: 20, letterSpacing: '.12em', textTransform: 'uppercase' }}>
              Información de contacto
            </h3>
            {CONTACT_INFO.map((row) => (
              <div key={row.label} className="ct-row">
                <div className="ct-icon">{row.icon}</div>
                <div className="ct-txt">
                  <label>{row.label}</label>
                  {row.content}
                </div>
              </div>
            ))}
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="btn btn-wa">
              <span style={{ fontSize: 16 }}>💬</span> Escribir por WhatsApp
            </a>
          </div>
        </FadeIn>

        {/* Formulario */}
        <FadeIn delay={150}>
          {sent ? (
            <div style={{ background: '#FFFFFF', border: '1px solid #E8E3DA', borderTop: '3px solid #D4600A', padding: 40, textAlign: 'center' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
              <h3 style={{ fontFamily: "'Merriweather',serif", fontSize: 26, color: '#D4600A', marginBottom: 10 }}>
                ¡Mensaje enviado!
              </h3>
              <p style={{ color: '#7A8FA0', fontWeight: 300, fontSize: 14 }}>
                Nos pondremos en contacto pronto. También puedes escribirnos por WhatsApp.
              </p>
              <button
                className="btn btn-outline btn-sm"
                style={{ marginTop: 22, width: 'auto' }}
                onClick={() => { setSent(false); setForm(INITIAL_FORM); }}
              >
                Enviar otro
              </button>
            </div>
          ) : (
            <form className="form" onSubmit={handleSubmit} noValidate>
              <div className="form-row">
                <div className="fg">
                  <label htmlFor="nombre">Nombre completo *</label>
                  <input id="nombre" name="nombre" value={form.nombre} onChange={handleChange} placeholder="Tu nombre" required />
                </div>
                <div className="fg">
                  <label htmlFor="empresa">Empresa / Estación</label>
                  <input id="empresa" name="empresa" value={form.empresa} onChange={handleChange} placeholder="Nombre de la estación" />
                </div>
              </div>
              <div className="form-row">
                <div className="fg">
                  <label htmlFor="telefono">Teléfono *</label>
                  <input id="telefono" name="telefono" value={form.telefono} onChange={handleChange} placeholder="+57 300 000 0000" required />
                </div>
                <div className="fg">
                  <label htmlFor="email">Correo electrónico</label>
                  <input id="email" name="email" type="email" value={form.email} onChange={handleChange} placeholder="correo@ejemplo.com" />
                </div>
              </div>
              <div className="fg">
                <label htmlFor="servicio">Servicio requerido</label>
                <select id="servicio" name="servicio" value={form.servicio} onChange={handleChange}>
                  <option value="">Selecciona un servicio...</option>
                  {SERVICES.map((s) => (
                    <option key={s.name} value={s.name}>{s.name}</option>
                  ))}
                  <option value="Productos">Consulta de productos</option>
                  <option value="Emergencia">Atención de emergencia</option>
                  <option value="Otro">Otro</option>
                </select>
              </div>
              <div className="fg">
                <label htmlFor="mensaje">Describe tu necesidad</label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  value={form.mensaje}
                  onChange={handleChange}
                  rows={5}
                  placeholder="Cuéntanos sobre el estado de tu estación y qué tipo de servicio o producto necesitas..."
                />
              </div>
              <button type="submit" className="btn btn-fuel" style={{ width: '100%' }}>
                Enviar solicitud
              </button>
              <p style={{ fontSize: 11, color: '#9AABB8', textAlign: 'center' }}>
                O escríbenos al {WA_NUMBER.replace('57', '+57 ')} por WhatsApp para atención inmediata.
              </p>
            </form>
          )}
        </FadeIn>
      </div>
    </section>
  );
}
